'use strict'

// A sample component

const Form = {
    init: function () {
        if (document.querySelector('.js-btn-form')) {
            this.constructor();
            this.displayForm();
            if (document.querySelector('.js-submit-form')) {
                this.sendForm();
            }

            window.addEventListener('scroll', () => {
                this.checkOffset();
            })
        }
    },
    constructor() {
        this.lastName = document.querySelector('input[name="contact_last_name"]');
        this.firstName = document.querySelector('input[name="contact_first_name"]');
        this.email = document.querySelector('input[name="contact_email"]');
        this.phone = document.querySelector('input[name="contact_phone"]');
        this.company = document.querySelector('input[name="contact_company"]');
        this.message = document.querySelector('textarea[name="contact_message"]');
        this.optin_rgpd = document.querySelector('input[name="contact_optin_rgpd"]');
    },
    displayForm: function () {
        const btnsOpen = document.querySelectorAll('.js-btn-form');
        const btnClose = document.querySelector('.js-close-form');
        const formContainer = document.querySelector('.form__wrapper');
        btnsOpen.forEach(btn => {
            btn.addEventListener('click', () => {
                document.querySelector('body').style.overflow = "hidden";
                formContainer.classList.add('open');
            })
        })
        btnClose.addEventListener('click', () => {
            formContainer.classList.remove('open');
            document.querySelector('body').style.overflow = "visible";
        })
    },
    checkOffset: function () {
        const btnFixed = document.querySelector('.cta-bubble-blue');
        const footer = document.querySelector('.footer__wrapper');
        function getRectTop(el) {
            var rect = el.getBoundingClientRect();
            return rect.top;
        }
        if ((getRectTop(btnFixed) + document.body.scrollTop) + btnFixed.offsetHeight >= (getRectTop(footer) + document.body.scrollTop) - 10) {
            btnFixed.classList.add("disappear")
        }
        if (document.body.scrollTop + window.innerHeight < (getRectTop(footer) + document.body.scrollTop)) {
            btnFixed.classList.remove("disappear")
        }
    },
    sendForm: function () {
        const submitBtn = document.querySelector('.js-submit-form');
        submitBtn.addEventListener('click', (e) => {
            e.preventDefault();
            var formdata = this.getAllDatas();


            var requestOptions = {
                method: 'POST',
                body: formdata
            };

            fetch(api.contact, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.code == "error_validation") {
                        this.errorForm(result);
                    } else {
                        this.successForm(result.data.msg);
                        document.querySelector('.js-form').reset();
                    }
                })
                .catch(error => console.log('error', error));
        })
    },
    getAllDatas: function () {
        let formdata = new FormData(document.querySelector('.js-form'));
        return formdata;
    },
    successForm(message) {
        document.querySelector('.successMessage').innerHTML = message;
    },
    errorForm: function (error) {
        const { data } = error;
        const { errors } = data;

        const {
            contact_last_name,
            contact_first_name,
            contact_email,
            contact_phone,
            contact_company,
            contact_message,
            contact_optin_rgpd
        } = errors;

        contact_last_name ? this.errors.inputText(this.lastName, contact_last_name) : this.valid.inputText(this.lastName);
        contact_first_name ? this.errors.inputText(this.firstName, contact_first_name) : this.valid.inputText(this.firstName);
        contact_email ? this.errors.inputText(this.email, contact_email) : this.valid.inputText(this.email);
        contact_phone ? this.errors.inputText(this.phone, contact_phone) : this.valid.inputText(this.phone);
        contact_company ? this.errors.inputText(this.company, contact_company) : this.valid.inputText(this.company);
        contact_message ? this.errors.inputText(this.message, contact_message) : this.valid.inputText(this.message);
        contact_optin_rgpd ? this.errors.inputText(this.optin_rgpd, contact_optin_rgpd) : this.valid.inputText(this.optin_rgpd);
        grecaptcha.reset();
    },


    errors: {
        inputText(element, message) {
            element.parentElement.querySelector('.errorMessage').innerHTML = message;
        }
    },
    valid: {
        inputText(element) {
            element.parentElement.querySelector('.errorMessage').innerHTML = "";
        }
    }

}


export default Form;
